import { Badge, Button, Col, Form, Input, Row, Space } from "antd";
import { useFetcher } from "react-router-dom";
import * as APITypes from "src/API";
import customParseFormat from "dayjs/plugin/customParseFormat";
import dayjs from "dayjs";
import { FormattedLeaseData } from "~/types/lease";
import { INTENTS } from "~/utils";
// TODO: [Translation]

// type FieldType = {
//   username?: string;
//   password?: string;
//   remember?: string;
// };

export const RenewalApplicationDetails = ({
  nextLeaseData,
}: {
  nextLeaseData: FormattedLeaseData | null;
}) => {
  dayjs.extend(customParseFormat);
  let landlordComplete = false;
  const fetch = useFetcher();
  const isSubmitting = fetch.state !== "idle";

  const agree = () => {
    fetch.submit(
      {
        body: JSON.stringify({
          offerID: nextLeaseData?.offer?.id ?? "",
        }),
        intent: INTENTS._agree_to_renewal,
      },
      {
        method: "post",
      }
    );
  };

  if (
    nextLeaseData?.offer?.status === APITypes.OfferStatusType.LandlordComplete
  ) {
    landlordComplete = true;
  }

  return (
    <>
      <Space direction="vertical">
        {nextLeaseData?.offer?.status ===
          APITypes.OfferStatusType.Completed && (
          <Badge status="success" text="Completed" />
        )}
        {nextLeaseData?.offer?.status === APITypes.OfferStatusType.Rejected && (
          <Badge status="error" text="Rejected" />
        )}
        {nextLeaseData?.offer?.status === APITypes.OfferStatusType.Canceled && (
          <Badge status="error" text="Canceled" />
        )}
        {nextLeaseData?.offer?.status ===
          APITypes.OfferStatusType.InProgress && (
          <Badge status="processing" text="In Progress" />
        )}
        {nextLeaseData?.offer?.status === APITypes.OfferStatusType.Pending && (
          <Badge status="processing" text="Pending" />
        )}
        {nextLeaseData?.offer?.status ===
          APITypes.OfferStatusType.TenantComplete && (
          <Badge status="warning" text="Tenant Complete" />
        )}
        {nextLeaseData?.offer?.status ===
          APITypes.OfferStatusType.LandlordComplete && (
          <Badge status="warning" text="Landlord Complete" />
        )}
      </Space>
      <br />
      <br />

      <Form name="basic" layout="vertical" disabled>
        <Row gutter={12} style={{ marginTop: "2rem" }}>
          <Col span={8}>
            <Form.Item name="Lease" label="Choosen Lease Renewal Option">
              <Input defaultValue={nextLeaseData?.leaseInfo?.type} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="Lease"
              label="Choosen Preferred Rent Payment Method"
            >
              <Input
                defaultValue={nextLeaseData?.application?.rentPaymentPreference?.toString()}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="Lease" label="Addional Notes">
              <Input.TextArea
                rows={6}
                defaultValue={nextLeaseData?.comment?.text}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
      {landlordComplete && (
        <Form
          name="basic"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          style={{ maxWidth: 600 }}
          onFinish={agree}
          disabled={isSubmitting}
        >
          {/* <Form.Item
            name="agreement"
            valuePropName="checked"
            rules={[
              {
                validator: (_, value) =>
                  value
                    ? Promise.resolve()
                    : Promise.reject(new Error("Should accept agreement")),
              },
            ]}
          >
            <Checkbox>
              I agree to the terms of the lease renewal policy.
            </Checkbox>
          </Form.Item> */}

          <Form.Item>
            <Button type="primary" htmlType="submit" loading={isSubmitting}>
              Submit
            </Button>
          </Form.Item>
        </Form>
      )}
    </>
  );
};
